import Vue from 'vue';
import Vuex from 'vuex';
import { state, mutations, actions, getters } from './entities';
import packageModules from './modules/packageModules';

import product from './modules/productConfig'
import user from './modules/SAASUser'
import onboarding from "./modules/onboarding";


import packageConfig from './modules/packageConfig'
import featureConfig from './modules/featureConfig'
import zone from './modules/zoneManagement'
import vehicleType from './modules/vehicleType'
import dashboard from './modules/dashboard';



Vue.use(Vuex);


export default new Vuex.Store({
    modules: {
        packageModules,
        packageConfig,
        product,
        zone,
        user,
        featureConfig,
        onboarding,
        vehicleType,
        dashboard,
    },
    state,
    actions,
    mutations,
    getters
})